import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";

// @material-ui/icons
import Contacts from "@material-ui/icons/Contacts";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { Controller, useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ImageUpload from "../../components/CustomUpload/ImageUpload";
import { stakingService } from "../../services/stakingService";
import { Remove } from "@material-ui/icons";
import Select from "components/Select/Select";
import { chainOptions } from "const";

const useStyles = makeStyles(styles);

export default function StakingCreateNormal() {
  const { register: staking, handleSubmit, setValue, control } = useForm();
  const { id } = useParams();
  const history = useHistory();
  const [collections, setCollections] = useState([]);
  const [detail, setDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  async function create(payload) {
    try {
      if (isLoading) return;
      setIsLoading(true);
      const { data } = await stakingService.createNormal({
        ...payload,
        chainId: payload.chainId || 25,
      });
      toast.success("Created");
      window.setTimeout(() => history.push("/admin/staking/" + data._id), 500);
    } catch (e) {
      toast.error(e?.response?.data?.message[0]);
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  async function update(payload) {
    try {
      if (isLoading) return;
      setIsLoading(true);
      await stakingService.update(id, payload);
      toast.success("Updated");
      window.setTimeout(() => history.push("/admin/staking/"), 500);
    } catch (e) {
      toast.error(e?.response?.data?.message[0] || "Cannot update");
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  async function onSubmit(form) {
    if (!form.rewardCoin || !form.name) {
      alert("please add data");
      return;
    }
    const totalRatio = collections.reduce((total, c) => total + +c.ratio, 0);
    if (totalRatio !== 100) {
      alert("total ratio must be 100");
      return;
    }
    const payload = {
      ...form,
      collections: collections.filter((c) => !!c.address),
    };
    if (id) {
      update(payload);
    } else {
      create(payload);
    }
  }

  async function fetchBanner() {
    try {
      const { data } = await stakingService.view(id);
      const fields = [
        "name",
        "image",
        "rewardCoin",
        "rewardCoinName",
        "description",
        "externalLink",
        "booster",
        "boosterName",
        "boosterRatio",
        "chainId",
      ];
      fields.forEach((field) => setValue(field, data[field]));
      setCollections(data.collections);
      setDetail({
        address: data.address,
        status: data.status,
      });
    } catch (e) {
      console.log(e);
    }
  }

  function updateCollection(index, field, value) {
    const tmp = [...collections];
    tmp[index] = { ...tmp[index], [field]: value };
    setCollections(tmp);
  }

  function addCollection() {
    setCollections([...collections, {}]);
  }

  function removeColleciton(index) {
    const tmp = [...collections];
    tmp.splice(index, 1);
    setCollections(tmp);
  }

  React.useEffect(() => {
    if (id) {
      fetchBanner();
    }
  }, [id]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Contacts />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>{!id ? "Create Staking" : "Edit Staking"}</h4>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={8}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Name</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...staking("name"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Address</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          type: "text",
                          value: detail.address,
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  {["not_deployed", undefined].includes(detail.status) && (
                    <Button onClick={addCollection}>Add Collection</Button>
                  )}

                  {collections.map((c, index) => (
                    <GridContainer key={index}>
                      <GridItem xs={12} sm={12} md={3}>
                        <FormLabel className={classes.labelHorizontal}>Nft collections</FormLabel>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <CustomInput
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            placeholder: "0xbaj24...",
                            type: "text",
                            value: c.address,
                            disabled: !["not_deployed", undefined].includes(detail.status),
                            onChange: (e) => updateCollection(index, "address", e.target.value),
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            placeholder: "Name",
                            type: "text",
                            value: c.name,
                            onChange: (e) => updateCollection(index, "name", e.target.value),
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            placeholder: "Ratio: 40",
                            type: "text",
                            value: c.ratio,
                            disabled: !["not_deployed", undefined].includes(detail.status),
                            onChange: (e) => updateCollection(index, "ratio", e.target.value),
                          }}
                        />
                      </GridItem>
                      <GridItem md={3} />
                      <GridItem xs={12} sm={12} md={5}>
                        <CustomInput
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            placeholder: "Buy link",
                            type: "text",
                            value: c.link,
                            onChange: (e) => updateCollection(index, "link", e.target.value),
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={2}>
                        <CustomInput
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            placeholder: "NFT Price: 150",
                            type: "text",
                            value: c.price,
                            onChange: (e) => updateCollection(index, "price", e.target.value),
                          }}
                        />
                      </GridItem>
                      {["not_deployed", undefined].includes(detail.status) && (
                        <GridItem xs={12} sm={12} md={2}>
                          <Button
                            justIcon={true}
                            onClick={() => removeColleciton(index)}
                            color="danger"
                            size="sm"
                          >
                            <Remove />
                          </Button>
                        </GridItem>
                      )}
                    </GridContainer>
                  ))}

                  <br />

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Reward coin</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          placeholder: "0xbaj24...",
                          disabled: !["not_deployed", undefined].includes(detail.status),
                          ...staking("rewardCoin"),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          placeholder: "CORGI",
                          type: "text",
                          ...staking("rewardCoinName"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Booster (optional)</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          placeholder: "0xbaj24...",
                          disabled: !["not_deployed", undefined].includes(detail.status),
                          ...staking("booster"),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: !["not_deployed", undefined].includes(detail.status),
                          placeholder: "20%",
                          type: "number",
                          ...staking("boosterRatio"),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          placeholder: "CORGI",
                          type: "text",
                          ...staking("boosterName"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Chain</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <Controller
                        control={control}
                        name="chainId"
                        render={({ field: { value, onChange } }) => (
                          <Select
                            name="chainId"
                            label=" "
                            onChange={onChange}
                            value={value ?? "25"}
                            options={chainOptions()}
                          />
                        )}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>External link</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...staking("externalLink"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Description</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          multiline: true,
                          rows: 4,
                          ...staking("description"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={9}>
                      <Button onClick={() => history.goBack()}>Cancel</Button>
                      <Button color="rose" type="submit">
                        {isLoading ? "Loading..." : "Submit"}
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={12}>
                      <p>Image: </p>
                      <Controller
                        control={control}
                        name="image"
                        render={({ field: { value, onChange } }) => (
                          <ImageUpload value={value} onChange={onChange} />
                        )}
                      />
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}></GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
